import { useState } from "react";
import { Grid, Button, Menu, MenuItem } from "@mui/material";
import { urlToDomain } from "./Utils";

export default function ScrapedListings(props) {
  const items = { realtor: [], compass: [], zillow: [] };
  if (props.estatedProperty.scraper.address) {
    props.estatedProperty.scraper.address.forEach((a) => {
      const domain = urlToDomain(a.listing_url);
      items[domain].push({
        address: `${a.value.street_address}, ${a.value.city}, ${a.value.state} ${a.value.zip_code}`,
        url: a.listing_url,
      });
    });
  }
  const [anchorEl, setAnchorEl] = useState(null);

  const onDomainClick = (event, key) => {
    if (items[key].length === 1) {
      window.open(items[key][0].url, "_blank");
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  return (
    <Grid container spacing={2}>
      {Object.keys(items).map((key) =>
        items[key].length ? (
          <Grid item key={key}>
            <Button
              variant="outlined"
              onClick={(event) => onDomainClick(event, key)}
              id={`sl-menu-${key}`}
            >
              <img
                style={{ paddingTop: 12, paddingBottom: 12 }}
                width="100"
                height="20"
                src={process.env.PUBLIC_URL + `/${key}.svg`}
                alt={key}
              />
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl && anchorEl.id === `sl-menu-${key}`)}
              onClose={() => setAnchorEl(null)}
            >
              {items[key].map((item) => (
                <MenuItem
                  key={item.url}
                  onClick={() => window.open(item.url, "_blank")}
                >
                  {item.address}
                </MenuItem>
              ))}
            </Menu>
          </Grid>
        ) : null
      )}
    </Grid>
  );
}
